import React from "react"
import styled from "styled-components"
import NextImg from "@/common/components/NextImg"
import KGLOGO from "@/common/assets/image/moneyFortune/second-floor/KGLOGO.webp"
import signbord1 from "@/common/assets/image/moneyFortune/second-floor/signboard-1.webp"
import signbord2 from "@/common/assets/image/moneyFortune/second-floor/signboard-2.webp"
import NFT01 from "@/common/assets/image/moneyFortune/second-floor/NFT01.webp"
import NFT02 from "@/common/assets/image/moneyFortune/second-floor/NFT02.webp"

export default function BGOthers() {
  return (
    <Wrapper>
      <KGLOGOWrapper>
        <KGLogo>
          <NextImg src={KGLOGO} />
        </KGLogo>
      </KGLOGOWrapper>
      <SignBoardWrapper1>
        <SignBoard1>
          <NextImg src={signbord1} />
        </SignBoard1>
      </SignBoardWrapper1>
      <SignBoardWrapper2>
        <SignBoard2>
          <NextImg src={signbord2} />
        </SignBoard2>
      </SignBoardWrapper2>
      <NFTWrapper1>
        <NFT1>
          <NextImg src={NFT01} />
        </NFT1>
      </NFTWrapper1>
      <NFTWrapper2>
        <NFT2>
          <NextImg src={NFT02} />
        </NFT2>
      </NFTWrapper2>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  height: 100vh;
  position: relative;
`

// ==========================================================
const KGLOGOWrapper = styled.div`
  position: absolute;
  width: 8%;
  top: 10%;
  left: 3%;
  transform: rotate(90deg);
`

const KGLogo = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: 24.68%;
`
// ==========================================================
const SignBoardWrapper1 = styled.div`
  position: absolute;
  width: 18%;
  bottom: 80px;
  left: 0%;
`
const SignBoard1 = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: 36.56%;
`
// ==========================================================
const SignBoardWrapper2 = styled.div`
  position: absolute;
  width: 15%;
  bottom: 80px;
  right: 0%;
`

const SignBoard2 = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: 109.09%;
`
// ==========================================================
const NFTWrapper1 = styled.div`
  position: absolute;
  width: 6%;
  top: 45%;
  left: 20%;
`

const NFT1 = styled.div`
  position: relative;
  width: 100%;
`
// ==========================================================
const NFTWrapper2 = styled.div`
  position: absolute;
  width: 2%;
  top: 20%;
  left: 35%;
`

const NFT2 = styled.div`
  position: relative;
  width: 100%;
`
// ==========================================================
